import { Head } from '@inertiajs/react';
import Layout from '@/layouts/layout';
import { toUrl } from '@/lib/utils';

export default function Contact() {
    const bookingAgents = [
        {
            name: 'Roger Urhaug',
            uri: 'roger.urhaug',
            domain: 'kalleklev.no',
            url: 'https://kalleklev.no',
            company: 'Kalleklev Management',
        },
    ];

    return (
        <Layout>
            <Head title="Contact" />

            <div className="p-8">
                {bookingAgents && (
                    <div className="py-4">
                        <span className="text-xl font-bold">Booking</span>
                        {bookingAgents.map((agent, idx) => (
                            <div key={idx} className="flex flex-col pt-1">
                                <div>
                                    <a
                                        href={toUrl(agent.url)}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        className="text-md font-bold underline hover:bg-primary hover:text-secondary"
                                    >
                                        {agent.company}
                                    </a>
                                </div>
                                <span>{agent.name}</span>
                                {agent.uri} [at] {agent.domain}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Layout>
    );
}
